import { ChartBuilder } from 'Molecules/InsightsChart/chartBuilder';
import { ChartType } from '../chartTypes';
import { BarChartData } from 'Molecules/InsightsChart/chartBuilder';
import { BaseInsightPayload } from '../InsightDataPayload';
import { parseUsersTypePayload } from '../payloads/usersTypePayload';
import { InsightChartFactory } from '../insightChartFactory';
import DefaultChartWithTrendSupport from 'Molecules/InsightsChart/DefaultChartWithTrendSupport';

export const buildUsersTypeInsightFactory = (
  payload: BaseInsightPayload
): InsightChartFactory => {
  const parsedPayload = parseUsersTypePayload(payload);
  const { data } = parsedPayload.data.attributes;

  return (props) => {
    const chart = new ChartBuilder()
      .setChartType(ChartType.DONUT)
      .setProps({
        chartData: data as BarChartData,
        onDrillDown: props.onDrillDown,
        valueFieldName: 'user_count',
        categoryFieldName: 'user_type',
      })
      .build();

    return DefaultChartWithTrendSupport({
      chartComponent: chart,
      trendData: {
        value: parsedPayload.data.attributes.aggregate.total_users.current ?? 0,
        trend:
          parsedPayload.data.attributes.aggregate.total_users
            .percentage_change ?? 0,
        trendIsPercent: true,
        description: props.name,
      },
    });
  };
};
